import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import './App.css';

import Header from './components/Header'
import IntroBlock from './components/Intro-Block'
import About from './pages/About'
import Footer from './pages/Footer'


class App extends React.Component {

  render() {
    return (
      <div className='App'>
        <Header />
        <Switch>
          <Route exact path='/' component={IntroBlock} />
          <Route path='/about' component={About} />
        </Switch>
        <Footer />
      </div>
    )
  }
}

export default App;
